import { Component, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GtmService } from './services/gtm.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'pdf-to-word-converter';

  constructor(
    private router: Router,
    private gtmService: GtmService
  ) {}

  ngOnInit(): void {
    // Initialiser GTM
    this.gtmService.init();

    // Écouter les changements de route
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navigationEnd = event as NavigationEnd;
        // Envoyer l'événement de changement de page à GTM
        this.gtmService.trackPageView(navigationEnd.url, this.getPageTitle(navigationEnd.url));
      });
  }

  /**
   * Obtient le titre de la page basé sur l'URL
   */
  private getPageTitle(url: string): string {
    const routeMap: { [key: string]: string } = {
      '': 'Accueil - PDF to Word Converter',
      '/progress-page': 'Conversion en cours',
      '/email-page': 'Page Email',
      '/checkout': 'Paiement',
      '/success': 'Conversion réussie',
      '/tarification': 'Tarification',
      '/mentions-legales': 'Mentions légales',
      '/politique-de-confidentialite': 'Politique de confidentialité',
      '/conditions-generales-ventes': 'Conditions générales de vente',
      '/contact': 'Contact',
      '/login': 'Connexion',
      '/espace-client': 'Espace client',
      '/unsubscribe': 'Désabonnement',
      '/supprimer-mes-donnees-personnelles': 'Suppression de données',
      '/suppression-de-donnees': 'Suppression de données'
    };

    return routeMap[url] || 'PDF to Word Converter';
  }
}
